import { SVGProps } from "react";

const PoolIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4 7.87317V17.4732C4 18.5933 4 19.153 4.21799 19.5809C4.40973 19.9572 4.71547 20.2635 5.0918 20.4552C5.5192 20.673 6.07899 20.673 7.19691 20.673H16.8031C17.921 20.673 18.48 20.673 18.9074 20.4552C19.2837 20.2635 19.5905 19.9572 19.7822 19.5809C20 19.1535 20 18.5945 20 17.4766V7.86988C20 6.75197 20 6.19218 19.7822 5.76477C19.5905 5.38845 19.2837 5.08271 18.9074 4.89096C18.4796 4.67297 17.9203 4.67297 16.8002 4.67297H7.2002C6.08009 4.67297 5.51962 4.67297 5.0918 4.89096C4.71547 5.08271 4.40973 5.38845 4.21799 5.76477C4 6.19259 4 6.75306 4 7.87317Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 14.0731V11.2731C15 10.713 14.9996 10.4328 14.8906 10.2189C14.7948 10.0307 14.6423 9.87784 14.4542 9.78197C14.2403 9.67297 13.9597 9.67297 13.3996 9.67297H10.5996C10.0396 9.67297 9.75981 9.67297 9.5459 9.78197C9.35774 9.87784 9.20487 10.0307 9.10899 10.2189C9 10.4328 9 10.713 9 11.2731V14.0731C9 14.6331 9 14.9128 9.10899 15.1267C9.20487 15.3148 9.35774 15.4682 9.5459 15.5641C9.7596 15.673 10.039 15.673 10.598 15.673H13.4011C13.96 15.673 14.2405 15.673 14.4542 15.5641C14.6423 15.4682 14.7948 15.3148 14.8906 15.1267C14.9996 14.9128 15 14.6331 15 14.0731Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PoolIcon;
